import Vue from 'vue'
import Toast from "vue-toastification"
import "vue-toastification/dist/index.css"

Vue.use(Toast, {
  timeout: 3000,
  position: "top-center",
  draggable: false
})



// WEBPACK FOOTER //
// ./src/common/js/toastification.js